import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useConditionalVisibility } from '../../../_hooks/useConditionalVisibility';

const CustomTextareaField = ({ question }) => {
      
  const { label, fieldId, size = "small",defaultValue='', rules,disable, isHidden} = question;
  const {control, formState: { errors }} = useFormContext();

  const isVisible = useConditionalVisibility(question.dependantConditions );
  if (!isVisible && isHidden) return null;

  return (
    <Controller
      name={fieldId}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          multiline
          minRows={3}
          variant="outlined"
          size={size}
          disabled={disable}
          label={label}
          error={!!errors[fieldId]}
          helperText={errors[fieldId]?.message}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};

export default CustomTextareaField;
